import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { Typography } from '@mui/material';

const SelectRemitenteEmail = ({value,disabled,onChange,isClearable,errorText,valRequerido, ...props}) => {

    const [selectedValue, setSelectedValue] = useState();
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([
        {
            value: 'support@nubicomv2.zohodesk.com',
            label: 'support@nubicomv2.zohodesk.com'
        },{
            value: 'no-reply@nubicom.com.ar',
            label: 'no-reply@nubicom.com.ar'
        },{
            value: 'facturas@nubicom.com.ar',
            label: 'facturas@nubicom.com.ar'
        },{
            value: 'helpdesk@nubicom.com.ar',
            label: 'helpdesk@nubicom.com.ar'
        },{
            value: 'soporte@nubicom.com.ar',
            label: 'soporte@nubicom.com.ar'
        },{
            value: 'soportesaltasegura@nubicom.com.ar',
            label: 'soportesaltasegura@nubicom.com.ar'
        },{
            value: 'facturas@nubicomv2.zohodesk.com.ar',
            label: 'facturas@nubicomv2.zohodesk.com.ar'
        }
    ]);

    const onSelectValue =
        useMemo(() =>
            (ev) => {
                if(ev){
                    ev.item = options.find(it=>it.value === ev.value);
                    onChange(ev);
                } else {
                    onChange(null);
                }
            }
        , [])

    useEffect(() => {
        const newOptions = items
            .map((item) => {
            return {
                value: item.value,
                label: item.label,
            };
        });
        setOptions(newOptions);
    }, [items]);

    useEffect(() => {
        if( options.length > 0 ){
            if (typeof value === 'string') {
                setSelectedValue( options.find((opt) => opt.value === value) );
            }
        }
    }, [options,value])

    useEffect(() => {
        if(valRequerido){
            setItems([
                {
                    value: 'Activo',
                    label: 'Requerido'
                },{
                    value: 'Inactivo',
                    label: 'No Requerido'
                }
            ])
        }
    }, [valRequerido])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...props}
            className='react-select-container'
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder='Seleccione...'
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
        />
    );
};

SelectRemitenteEmail.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectRemitenteEmail;